import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "helpers/text";
import useMediaQueries, { MediaQueries } from "hooks/UseMediaQueries";
import { Co2AverageProps, WidgetEntity } from "models/Widget";

import Co2AverageGraph from "../../content/Co2AverageGraph";
import DateTimeOfData from "../../materials/DateTimeOfData";

import * as styles from "./styles";

type IProps = {
	mediaQueries: MediaQueries;
	narrowedWidget: WidgetEntity & {
		props: Co2AverageProps;
	};
};

type IState = Record<string, never>;

class Component extends React.Component<IProps, IState> {
	public override render() {
		return (
			<Box sx={styles.root(this.props.mediaQueries)}>
				<Co2AverageGraph narrowedWidget={this.props.narrowedWidget} />
				<Divider orientation={this.props.mediaQueries.isLg ? "vertical" : "horizontal"} variant="middle" />
				<Box sx={styles.date(this.props.mediaQueries)}>
					<Typography sx={styles.atmoName}>{capitalizeFirstLetter(this.props.narrowedWidget.data[0]?.name)}</Typography>
					<DateTimeOfData
						fromDate={new Date(this.props.narrowedWidget.props.from)}
						toDate={new Date(this.props.narrowedWidget.props.to)}
					/>
				</Box>
			</Box>
		);
	}
}

export default function Co2AverageView(props: Omit<IProps, "mediaQueries">) {
	const mediaQueries = useMediaQueries();

	return <Component {...{ ...props, mediaQueries }} />;
}
